import { Menu } from "@legacy/Menu";
import { MenuItem } from "@mui/material";
import { Tabs } from "@navigations/Tabs";
import { removeDuplicateEntriesInArray } from "@utils/index";
import {
  fetchActionByCommunication,
  getActionsFromAmp,
  isDisabledAction,
  isDisabledOptInPhone,
  sortActionsByNextStatusIsInPipeIsMatching,
} from "../../business-logic";
import { ActionButton, ActionTab } from "./styles";

/**
 * Default render for action dispatcher
 * @param {String} id
 * @param {Object} managementProcess
 * @param {Function} actionDispatcher
 * @param {Array} selectedApplies
 * @param {Boolean} isLoading
 */
export const DefaultRenderActions = ({ id, managementProcess, actionDispatcher, selectedApplies, isLoading }) => {
  // get action from AMP
  const actions = getActionsFromAmp({ managementProcess });
  // remove deplicate action with same next status and sort with status in pipe isMatching or not
  const actionsUnique = removeDuplicateEntriesInArray(actions, "nextStatus", "key");
  // sort actions to put refuse action lastest
  const actionsSort = sortActionsByNextStatusIsInPipeIsMatching({
    actions: actionsUnique,
  });
  // fetch and format action
  const actionsFetchAndFormated = fetchActionByCommunication({
    actions: actionsSort,
  });
  // handle click
  const handleClick = (event, action) => {
    event.preventDefault();
    actionDispatcher(action);
  };

  return (
    <Tabs
      key={`actions-dispatcher-default-render-${id}`}
      hideIndicator
      variant="scrollable"
      scrollButtons="auto"
      TabScrollButtonProps={{
        size: "small",
      }}
    >
      {!actionsFetchAndFormated?.communicationActions?.length ? null : (
        <ActionTab
          key={`actions-dispatcher-default-render-ActionTab-communicationActions-${id}`}
          component="span"
          label={
            <Menu
              id={`actions-dispatcher-default-render-dropdown-${id}`}
              key={`actions-dispatcher-default-render-dropdown-${id}`}
              buttonText="envoyer"
              buttonProps={{
                size: "xs-flat",
              }}
              disabled={
                actionsFetchAndFormated.communicationActions.filter((action) =>
                  isDisabledAction({ action, selectedApplies, isLoading })
                ).length === actionsFetchAndFormated.communicationActions.length ||
                !!isDisabledOptInPhone({ selectedApplies })
              }
            >
              {actionsFetchAndFormated.communicationActions.map((action, index) => (
                <MenuItem
                  id={`actions-dispatcher-default-render-menuitem-${id}-${index}`}
                  // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                  key={index}
                  disabled={
                    !!isDisabledAction({
                      action,
                      selectedApplies,
                      isLoading,
                    }) || !!isDisabledOptInPhone({ selectedApplies })
                  }
                  onClick={(e) => {
                    handleClick(e, action);
                  }}
                >
                  {action.name}
                </MenuItem>
              ))}
            </Menu>
          }
        />
      )}
      {!actionsFetchAndFormated &&
      !actionsFetchAndFormated.normalActions &&
      !actionsFetchAndFormated.normalActions.length
        ? null
        : actionsFetchAndFormated.normalActions.map((action, index) => (
            <ActionTab
              key={`actions-dispatcher-default-render-ActionTab-normalActions-${id}`}
              component="span"
              label={
                <ActionButton
                  id={`actions-dispatcher-default-render-button-normal-${id}-${index}`}
                  key={`actions-dispatcher-default-render-button-normal-${id}`}
                  onClick={(e) => handleClick(e, action)}
                  size={"xs-flat"}
                  disabled={!!isDisabledAction({ action, selectedApplies, isLoading })}
                >
                  {action.name}
                </ActionButton>
              }
            />
          ))}
    </Tabs>
  );
};
